<template>
  <v-dialog width="500" :value="show" @click:outside="closing">
    <v-row no-gutters class="white" style="overflow: hidden">
      <v-col class="col-12">
        <v-alert
          class="my-0 pt-8 px-8 text-center"
          border="top"
          colored-border
          tile
          :type="type"
          elevation="0"
        >
          <!-- <span>{{ message }}</span> -->
          <p  class="pl-1" v-html="message" />
        </v-alert>
      </v-col>
      <v-col class="col-12">
        <div align="center" justify="center" class="pt-2 mb-5">
          <v-btn
            color="leading"
            width="150"
            dark
            class
            @click="closing"
          >
            Volver
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-dialog>
</template>
<script>


export default {
  name: 'MessageBox',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: () => '',
    },
    type: {
      type: String,
      default: () => 'info'
    }
  },  
  methods:{
    closing(){
      this.$emit('closing')
    }
  }
}

</script>
<style scoped>
/* p{
  line-height: 3rem;
} */
>>> .v-alert__icon.v-icon {
  font-size: 25px !important;
  margin: 0;
}
</style>
